import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
import Navbarside from "../../../common/Navbarside";
import { Link, useNavigate, useParams } from "react-router-dom";
import Footer from "../../../common/footer";
import { useGeolocated } from "react-geolocated";
import { get, getById, post, put } from "../../../apiHandler/commons";
import { component } from "../data";
import Loader from "../../../common/Loader";
import { avatarGroupClasses } from "@mui/material";

const UpdateLabDetails = () => {
  const [cities, setCities] = useState([]);
  const [states, setStates] = useState([]);
  const [category, setCategory] = useState([]);
  const [name, setName] = useState("");
  const [labEmail, setLabEmail] = useState("");
  const [labMobileNo, setLabMobileNo] = useState("");
  const [address, setAddress] = useState("");
  const [agreement, setAgreement] = useState("");
  const navigate = useNavigate();
  //   const dispatch = useDispatch();
  const [checked, setChecked] = useState([]);
  const [servicechecked, setServiceChecked] = useState([]);
  const [serviceType, setServiceType] = useState([]);
  const [long, setLong] = useState("");
  const [lat, setLat] = useState("");
  const [cityId, setcityId] = useState("");
  const [city, setCity] = useState("");
  const [stateId, setstateId] = useState("");
  const [state, setState] = useState("");
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [fileNameData, setFileNameData] = useState("");

  const { coords, isGeolocationAvailable, isGeolocationEnabled } =
    useGeolocated({
      positionOptions: {
        enableHighAccuracy: false,
      },
      userDecisionTimeout: 5000,
    });


  const handleCheck = (event,id) => {
    var updatedList = [...checked];
    if (event.target.checked) {
      updatedList = [...checked, {name :event.target.value, _id:id}];
    } else {
      updatedList.splice(checked.findIndex(item => item.name === event.target.value), 1);
    }
    setChecked(updatedList);
  };

  const handleServiceCheck = (event) => {
    var updatedList = [...serviceType];
    if (event.target.checked) {
      updatedList = [...serviceType, event.target.value];
    } else {
      updatedList.splice(serviceType.indexOf(event.target.value), 1);
    }
    setServiceType(updatedList);
  };

  React.useEffect(() => {
    // Get city call
    setIsLoading(true);
    get("city", { page: 0 })
      .then((res) => {
        setIsLoading(false);
        setCities(res?.data);
        setcityId(res?.data[0]._id);
        setCity(res?.data[0].name);
      })
      .catch((e) => {
        setIsLoading(false);

        alert("Sometjing went wrong");
      });
    // get State call
    setIsLoading(true);
    get("state", { page: 0 })
      .then((res) => {
        setIsLoading(false);
        setStates(res?.data);
        setstateId(res?.data[0]._id);
        setState(res?.data[0].name);
      })
      .catch((e) => {
        setIsLoading(false);
        alert("Sometjing went wrong");
      });
    // get kab category call
    setIsLoading(true);
    get("labTestCategory", { page: 0 })
      .then((res) => {
        setIsLoading(false);
        setCategory(res?.data);
      })
      .catch((e) => {
        setIsLoading(false);
        alert("Sometjing went wrong");
      });
    getLabDetails();
  }, []);

  const fileName = (url) => {
    const parts = url.split("/");
    const index = parts.indexOf("healthonify");
    const fileName = parts.slice(index + 1).join("/");
    if (fileName?.length > 0) {
      return fileName;
    }
    return "";
  };


  const getLabDetails = () => {
    // Get Lab Call
    setIsLoading(true);
    getById(component.module, id)
      .then((res) => {
        setIsLoading(false);
        let update = [];
        res?.data[0]?.labTestCategoryId?.forEach((obj) =>
          {
            update.push({name:obj?.name, _id:obj?._id})
          }
        );
        setChecked(update);
        setName(res?.data[0]?.name);
        setLabEmail(res?.data[0]?.labEmail);
        setLabMobileNo(res?.data[0]?.labMobileNo);
        setAddress(res?.data[0]?.address);
        setAgreement(res?.data[0]?.agreement);
        // const name =
        setCity(
          cities?.filter((data) => (data._id = res?.data[0]?.cityId))[0]?.name
        );
        setState(
          states?.filter((data) => (data._id = res?.data[0]?.stateId))[0]?.name
        );
        // setcityId(res?.data[0]?.cityId)
        // setstateId(res?.data[0]?.stateId)
        setServiceType(res?.data[0]?.serviceType);
        setFileNameData(fileName(res?.data[0]?.agreement));
        // fileName(res?.data[0]?.agreement);
      })
      .catch((e) => {
        alert("Something went wrong");
        setIsLoading(false);
      });
  };

  
  async function upload(e) {
    let labTestCategoryId = checked;
  let serviceT = serviceType;
  let latitude = lat;
  let longitude = long;
    e.preventDefault();
    let location = {
      type: "Point",
      coordinates: [13.00345, 77.662795],
    };

    let vendorId = JSON.parse(localStorage.getItem("user")).id;
    let item = {
      set:{
        name,
        labEmail,
        labMobileNo,
        vendorId,
        labTestCategoryId,
        address,
        location,
        serviceType:serviceT,
        agreement,
        cityId,
        stateId,
        id,
      }

    };

    put(component.module, item, id)
      .then(() => {
        alert("Uploaded succesfully");
        getLabDetails();
        
        // navigate("/MyLabs");
      })
      .catch((e) => {
        alert(e.message);
      });
  }

  async function imageUpload(e) {
    e.preventDefault();
    var formdata = new FormData();
    formdata.append("file", e.target.files[0]);
    var requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };
    let response = await fetch(
      "https://api-wm.healthonify.com/upload",
      requestOptions
    );
    let data = await response.json();
    setAgreement(data.data.location);
  }

  const receivedData = [{ value: "Home Service" }, { value: "Lab Visit" }];

  // alert movile number]

  const [alertname, setAlertName] = useState("");
  const [alertlabEmail, setAlertLabEmail] = useState("");
  const [alertlabMobileNo, setAlertLabMobileNo] = useState("");
  const [alertaddress, setAlertAddress] = useState("");
  const [alertagreement, setAlertAgreement] = useState("");

  const save = (e) => {
    const fName = /^(([A-Za-z]+[,.]?[ ]?|[a-z]+['-]?)+)$/;
    if (fName.test(name)) {
      setAlertName("");
    } else if (!fName.test(name) && name === "") {
      setAlertName("Please enter lab name");
    } else {
      setAlertName("Please enter a valid cname");
    }

    const regimage = /(gif|jpe?g|tiff?|png|webp|bmp|pdf|doc|docx)$/i;
    if (regimage.test(agreement)) {
      setAlertAgreement("");
    } else if (!regimage.test(agreement) && agreement === "") {
      setAlertAgreement("Please upload lab document");
      e.preventDefault();
    } else {
      setAlertAgreement("Invalid file");
      e.preventDefault();
    }

    const regallchar = /^(.|\s)*[a-zA-Z]+(.|\s)*$/;
    if (regallchar.test(address)) {
      setAlertAddress("");
    } else if (!regallchar.test(address) && address === "") {
      setAlertAddress("Please enter lab address");
      e.preventDefault();
    } else {
      setAlertAddress("");
    }

    const emailrgex =
      /[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}(.[a-z{2-8}])?/g;
    if (emailrgex.test(labEmail)) {
      setAlertLabEmail("");
    } else if (!emailrgex.test(labEmail) && labEmail === "") {
      setAlertLabEmail("Please enter the lab email");
      e.preventDefault();
    } else {
      setAlertLabEmail("Please enter a valid email");
    }

    const mobile = /^(\+\d{1,3}[- ]?)?\d{10}$/;
    if (mobile.test(labMobileNo)) {
      setAlertLabMobileNo("");
    } else if (!mobile.test(labMobileNo) && labMobileNo === "") {
      setAlertLabMobileNo("Please enter the lab mobile number");
      e.preventDefault();
    } else {
      setAlertLabMobileNo("Please enter a valid mobile number");
    }
  };

  const cancel = (e) => {
    setName("");
    setLabEmail("");
    setLabMobileNo("");
    setAddress("");
    setAgreement("");
    setAlertName("");
    setAlertLabEmail("");
    setAlertLabMobileNo("");
    setAlertAddress("");
    setAlertAgreement("");
  };

  const handleCityChange = (e) => {
    var value = cities.filter(function (citys) {
      return citys.name == e.target.value;
    });
    setcityId(value[0]._id);
    setCity(value[0].name);
  };

  const handleStateValChange = (e) => {
    var value = states.filter(function (states) {
      return states.name == e.target.value;
    });
    setstateId(value[0]._id);
    setState(value[0].name);
  };

  return !isGeolocationAvailable ? (
    <div>Your browser does not support Geolocation</div>
  ) : !isGeolocationEnabled ? (
    <div>Geolocation is not enabled</div>
  ) : coords ? (
    <body data-col="2-columns" className=" 2-columns ">
      <Navbarside />
      {isLoading && <Loader />}

      <div className="container-fluid pb-5 response-cover">
        <div className="row">
          <div className="col-lg-2 col-md-4" />
          <div className="col-lg-10 col-md-8">
            <div className="container-fluid pt-5">
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="card-header">
                      <div className="card-title-wrap bar-danger d-flex align-items-center">
                        <h4 className="card-title">Add Lab</h4>
                      </div>
                    </div>

                    <section className="form-section">
                      <form onSubmit={upload}>
                        <div className="row">
                          <div className="col-md-6 col-sm-12 pt-2">
                            <p
                              className="col-black"
                              style={{ marginBottom: "2px" }}
                            >
                              Lab Name
                            </p>
                            <input
                              type="text"
                              placeholder="Lab name"
                              value={name}
                              onChange={(e) => setName(e.target.value)}
                              className="form-control"
                            />
                            <p className="alert-message">{alertname}</p>
                          </div>

                          <div className="col-md-6 col-sm-12 pt-2">
                            <p
                              className="col-black"
                              style={{ marginBottom: "2px" }}
                            >
                              Lab Email
                            </p>
                            <input
                              type="text"
                              placeholder="Enter email"
                              value={labEmail}
                              onChange={(e) => setLabEmail(e.target.value)}
                              className="form-control"
                            />
                            <p className="alert-message">{alertlabEmail}</p>
                          </div>

                          <div className="col-md-6 col-sm-12 pt-2">
                            <p
                              className="col-black"
                              style={{ marginBottom: "2px" }}
                            >
                              Mobile Number
                            </p>
                            <input
                              type="tel"
                              maxLength={10}
                              placeholder="Mobile number"
                              value={labMobileNo}
                              onChange={(e) => setLabMobileNo(e.target.value)}
                              className="form-control"
                            />
                            <p className="alert-message">{alertlabMobileNo}</p>
                          </div>
                          <div className="col-md-6 col-sm-12 pt-2">
                            <p
                              className="col-black"
                              style={{ marginBottom: "2px" }}
                            >
                              Lab Certificate
                            </p>

                            <input
                              type="file"
                              className="form-control-file"
                              Placeholder=""
                              name="pdf"
                              onChange={(e) => imageUpload(e)}
                              // required
                            />
                            <br />
                            {/* Display the file name */}
                            {fileNameData && (
                              <p>
                                Selected File:{" "}
                                <a href={agreement} target="_blank">
                                  {fileNameData}
                                </a>
                              </p>
                            )}
                            <p className="alert-message">{alertagreement}</p>
                          </div>

                          <div className="col-md-12 col-sm-12 pt-2">
                            <p
                              className="col-black"
                              style={{ marginBottom: "2px" }}
                            >
                              Address
                            </p>
                            <textarea
                              placeholder="Address"
                              value={address}
                              onChange={(e) => setAddress(e.target.value)}
                              className="form-control"
                            />
                            <p className="alert-message">{alertaddress}</p>
                          </div>
                        </div>

                        <div className="row pt-3">
                          <div className="col-md-6">
                            <div className="form-group">
                              <p className="col-black">City</p>
                              <select
                                className="form-control"
                                onChange={handleCityChange}
                                value={city}
                                required
                              >
                                <option value="">Select</option>
                                {cities.map((option) => (
                                  <option
                                    value={
                                      city?.length > 0 ? city : option.cityId
                                    }
                                  >
                                    {option.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <p className="col-black">State</p>
                              <select
                                className="form-control"
                                onChange={handleStateValChange}
                                value={state}
                                required
                              >
                                <option value="">Select</option>
                                {states.map((option) => (
                                  <option value={option.stateId}>
                                    {option.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="row pt-3">
                          <div className="col-12">
                            <p className="col-black">Service Type</p>
                          </div>
                          {receivedData?.map((data, index) => (
                            <div className=" col-lg-6 col-md-6 col-sm-12">
                              <input
                                type="checkbox"
                                value={data.value}
                                checked={serviceType?.includes(data?.value)}
                                name="services"
                                onChange={handleServiceCheck}
                              />{" "}
                              {data.value}
                            </div>
                          ))}

                          <div className="col-12 mt-3">
                            <p className="col-black">Tests</p>
                          </div>

                          {category.map((LabVal, index) => (
                            <div className=" col-lg-6 col-md-6 col-sm-12">
                              <input
                                type="checkbox"
                                name="services"
                                // checked={checked?.includes(LabVal.name)}
                                checked={checked?.some((obj)=>obj?.name === LabVal?.name)}
                                value={LabVal?.name}
                                onChange={(e)=>handleCheck(e,LabVal?._id)}
                              />
                              &nbsp;
                              {LabVal.name}
                            </div>
                          ))}
                        </div>
                        <input
                          type="text"
                          value={coords.longitude}
                          style={{ display: "none" }}
                          onChange={(e) => setLong(e.target.value)}
                        />
                        <input
                          type="text"
                          style={{ display: "none" }}
                          value={coords.latitude}
                          onChange={(e) => setLat(e.target.value)}
                        />

                        <div className="form-actions center">
                          <button
                            type="submit"
                            className="btn btn-primary"
                            onClick={save}
                          >
                            Submit
                          </button>
                          &nbsp; &nbsp; &nbsp;
                          <button
                            type="reset"
                            className="btn btn-warning"
                            onClick={cancel}
                          >
                            Cancel
                          </button>
                        </div>
                      </form>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </body>
  ) : (
    <div>Getting the location data&hellip; </div>
  );
  // : (
  //   <div>Getting the location data&hellip; </div>
  // );
};

export default UpdateLabDetails;
